import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenida, ${u.name}`);
      navigate(u.role === "admin" ? "/admin" : "/cuenta");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al iniciar sesión");
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-6 py-24" data-testid="login-page">
      <h1 className="font-serif text-5xl tracking-tighter">Bienvenida</h1>
      <p className="mt-2 text-[#5B605E]">Ingresa a tu cuenta para continuar.</p>
      <form onSubmit={submit} className="mt-10 space-y-4">
        <input data-testid="login-email" type="email" required placeholder="Correo" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border-b border-[#2C302E] py-3 focus:outline-none" />
        <input data-testid="login-password" type="password" required placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-transparent border-b border-[#2C302E] py-3 focus:outline-none" />
        <button data-testid="login-submit" disabled={loading} className="btn-primary w-full mt-6">{loading ? "Ingresando…" : "Iniciar sesión"}</button>
      </form>
      <button data-testid="google-login" disabled className="btn-ghost w-full mt-3 opacity-60 cursor-not-allowed">Continuar con Google (próximamente)</button>
      <p className="mt-6 text-sm text-[#5B605E]">¿Eres nueva? <Link to="/register" className="link-underline text-[#A94438]">Crea tu cuenta</Link></p>
      <div className="mt-8 text-xs text-[#5B605E] bg-[#F2EFE9] p-4 border border-[#E8E3DA]">
        <p className="font-medium mb-1">Cuentas de prueba:</p>
        <p>Admin · admin@tiendabonita.com / Admin123!</p>
        <p>Cliente · cliente@tiendabonita.com / Cliente123!</p>
      </div>
    </div>
  );
}
